import Tooltip from '@mui/material/Tooltip';
import clsx from 'clsx';

export interface DnpBadgeProps {
	className?: string;
}

/**
 * A small "DNP" (do-not-populate) badge.
 */
export function DnpBadge({ className }: DnpBadgeProps) {
	return (
		<Tooltip title='Marked do not populate in the selected package resolution' disableInteractive>
			<span
				className={clsx(
					'-my-0.75 rounded bg-gray-a3 px-1.5 py-0.75 text-[11px] leading-none font-medium text-gray-a10',
					className,
				)}
			>
				DNP
			</span>
		</Tooltip>
	);
}
